import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  SfCustomObjectProductMappingsApi,
  SfCustomObjectProductMappingsApiDeleteSfCustomObjectProductMappingRequest,
  SfCustomObjectProductMappingsApiGetSfContactRelationFieldsRequest,
  SfCustomObjectProductMappingsApiGetSfCustomObjectProductMappingRequest,
  SfCustomObjectProductMappingsApiUpsertSfCustomObjectProductMappingRequest,
  GetSfContactRelationFields200Response,
  GetSfCustomObjectProductMapping200Response,
  GetSfCustomObjects200Response,
} from '@/api/openapi';

export class SfCustomObjectProductMappingApiService extends ApiService {
  api = new SfCustomObjectProductMappingsApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getSfCustomObjects(
    args?: ApiArguments<void>,
  ): Promise<AxiosResponse<GetSfCustomObjects200Response>> {
    return this.checkResponse<GetSfCustomObjects200Response>(
      this.api.getSfCustomObjects(args?.options),
      args?.errorHandlers,
    );
  }

  async getSfContactRelationFields(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<SfCustomObjectProductMappingsApiGetSfContactRelationFieldsRequest>,
  ): Promise<AxiosResponse<GetSfContactRelationFields200Response>> {
    return this.checkResponse<GetSfContactRelationFields200Response>(
      this.api.getSfContactRelationFields(request, options),
      errorHandlers,
    );
  }

  async getSfCustomObjectProductMapping(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<SfCustomObjectProductMappingsApiGetSfCustomObjectProductMappingRequest>,
  ): Promise<AxiosResponse<GetSfCustomObjectProductMapping200Response>> {
    return this.checkResponse<GetSfCustomObjectProductMapping200Response>(
      this.api.getSfCustomObjectProductMapping(request, options),
      errorHandlers,
    );
  }

  async upsertSfCustomObjectProductMapping(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<SfCustomObjectProductMappingsApiUpsertSfCustomObjectProductMappingRequest>,
  ): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(
      this.api.upsertSfCustomObjectProductMapping(request, options),
      errorHandlers,
    );
  }

  async deleteSfCustomObjectProductMapping(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<SfCustomObjectProductMappingsApiDeleteSfCustomObjectProductMappingRequest>,
  ): Promise<AxiosResponse<void>> {
    return this.checkResponse<void>(
      this.api.deleteSfCustomObjectProductMapping(request, options),
      errorHandlers,
    );
  }
}
